<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Public Liability Proposal"
			productTypeLabel="Liability Type"
			selectProductInsuranceType="public_liability"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				public_liability_event_and_exhibition: "AegCaseLiabilityExhibition",
				public_liability_advertising_signs_and_decoration:
					"AegCaseLiabilitySignboard"
			}
		}
	}
}
</script>

<style></style>
